import React, { useState, useEffect } from 'react';
import ProjectSelector from './projectSelector/ProjectSelector';
import Search from './search/Search';
import CustomButton from '../../layout/customButton/CustomButton';
import styles from './UserListSection.module.scss';
import { connect } from 'react-redux';
import { openModal } from '../../../redux/modals/action';
import AddUserModal from './addUserModal/AddUserModal';
import { Grid, Button } from '@mui/material';
import {
	getClickedUser,
	getCompanies,
	getRoles,
	getUsers,
	setProjectSelectedCode,
} from '../../../redux/userManagement/actions';
import UserTable from './userTable/UserTable';
import Userdetailscard from './userDetailsCard/UserDetailsCard';
import EditAccessibilityModal from './editAccessibilityModal/EditAccessibilityModal';
import { ReactComponent as ArchiveIcon } from '../../../assets/icons/archive.svg';
import SettingsIcon from '@mui/icons-material/Settings';
import ConfirmationComponent from '../../confirmation/ConfirmationComponent';
import {
	setConfirmation,
	closeConfirmation,
} from '../../../redux/confirmations/actions';
import { deleteUser } from '../../../api/UserManagement/deleteUser.api';
import { setUserArchived } from '../../../api/UserManagement/setUserArchive.api';
import RoleActionsModal from './roleActionsModal/RoleActionsModal';

const UserListSection = ({
	openModal,
	modals,
	getUsers,
	userClicked,
	getCompanies,
	getRoles,
	setSection,
	setProjectSelectedCode,
	getClickedUser,
	confirmation,
	setConfirmation,
	closeConfirmation,
}) => {
	const [search, setSearch] = useState();
	const [userSelected, setUserSelected] = useState();
	const [projectSelected, setProjectSelected] = useState('');
	const [projectToEdit, setProjectToEdit] = useState();
	const [deleteUsersId, setDeleteUsersId] = useState([]);
	const [archiveUsersId, setArchiveUsersId] = useState([]);
	const [roleIdOfChip, setRoleIdOfChip] = useState('');
	const [userIdOfChip, setUserIdOfChip] = useState('');
	const [newRole, setNewRole] = useState();
	const [projectsList, setProjectsList] = useState();
	const [filterByRole, setFilterByRole] = useState('');

	const deleteUsersButtonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseDeleteUsersConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleDeleteUsersConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	const archiveUsersButtonList = [
		{
			name: 'Discard',
			action: () => {
				handleCloseArchiveUsersConfirmation();
			},
			style: {
				color: 'var(--primary)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
		{
			name: 'Yes',
			action: () => {
				handleArchiveUsersConfirmation();
			},
			style: {
				color: 'var(--white)',
				backgroundColor: 'var(--error)',
				fontWeight: 'bold',
				width: '175px',
				height: '42px',
			},
		},
	];

	const handleCloseDeleteUsersConfirmation = () => {
		closeConfirmation('deleteUsers');
	};

	const handleCloseArchiveUsersConfirmation = () => {
		closeConfirmation('archiveUsers');
	};

	const handleDeleteUsersConfirmation = async () => {
		for (let userId of deleteUsersId) {
			if (userId) {
				await deleteUser(userId);
			}
		}
		closeConfirmation('deleteUsers');
	};

	const handleArchiveUsersConfirmation = async () => {
		for (let userId of archiveUsersId) {
			if (userId) {
				await setUserArchived(userId);
			}
		}
		closeConfirmation('deleteUsers');
	};

	const handleAddUser = () => {
		setUserSelected();
		openModal('addUserMgmt');
	};

	const handleOpenDeleteUsersConfirmation = async (id) => {
		await setConfirmation('deleteUsers');
		setDeleteUsersId(id);
	};

	const handleOpenArchiveUsersConfirmation = async (id) => {
		await setConfirmation('archiveUsers');
		setArchiveUsersId(id);
	};

	const handleEditAccessibility = (id) => {
		console.log('handleEditAccessibility', userSelected);
		openModal('editAccessibility');
		setProjectToEdit(id);
	};

	useEffect(() => {
		getCompanies();
	}, []);

	useEffect(() => {
		getRoles(projectSelected);
	}, [projectSelected]);

	useEffect(() => {
		getUsers(projectSelected);
		setProjectSelectedCode(projectSelected);
	}, [projectSelected]);

	useEffect(() => {
		console.log('project selected', projectSelected);
	}, [projectSelected]);
	return (
		<div className={styles.userListSectionWrapper}>
			<Grid container className={styles.header} xs={12} spacing={1}>
				<Grid item xs={4}>
					<ProjectSelector
						projectSelected={projectSelected}
						setProjectSelected={setProjectSelected}
						setFilterByRole={setFilterByRole}
					/>
				</Grid>

				<Grid container item xs={4}>
					<Grid item xs={6} lg={8} xl={9}>
						<div className={styles.search}>
							<Search
								target={'Users'}
								search={search}
								setSearch={setSearch}
							/>
						</div>
					</Grid>
					<Grid item xs={6} lg={4} xl={3}>
						<div className={styles.add_user_btn}>
							<CustomButton
								onClick={() => handleAddUser()}
								width={166}
								height={42}
							>
								Add User
							</CustomButton>
						</div>
					</Grid>
				</Grid>
			</Grid>

			<Grid container xs={12} spacing={1}>
				<Grid item xs={8}>
					<UserTable
						search={search}
						setUserSelected={setUserSelected}
						openDeleteUsersConfirmation={
							handleOpenDeleteUsersConfirmation
						}
						openArchiveUsersConfirmation={
							handleOpenArchiveUsersConfirmation
						}
						setUserIdOfChip={setUserIdOfChip}
						setRoleIdOfChip={setRoleIdOfChip}
						filterByRole={filterByRole}
						setFilterByRole={setFilterByRole}
					/>
					<div className={styles.btn_groups}>
						<Button
							onClick={() => {
								setSection('role setting');
							}}
							startIcon={<SettingsIcon />}
							className={styles.role_preset_settings_btn}
						>
							Role Preset Settings
						</Button>
						<Button
							onClick={() => {
								setSection('user archive');
								getClickedUser('');
							}}
							startIcon={<ArchiveIcon />}
							className={styles.user_archive_btn}
						>
							User Archive
						</Button>
					</div>
				</Grid>
				<Grid item xs={4}>
					<Userdetailscard />
				</Grid>
			</Grid>
			<AddUserModal
				showModal={modals.addUserMgmt}
				userSelected={userSelected}
				handleEditAccessibility={handleEditAccessibility}
				openDeleteUsersConfirmation={handleOpenDeleteUsersConfirmation}
				openArchiveUsersConfirmation={
					handleOpenArchiveUsersConfirmation
				}
				setNewRole={setNewRole}
				newRole={newRole}
				projectsList={projectsList}
				setProjectsList={setProjectsList}
			/>

			<EditAccessibilityModal
				show={modals.editAccessibility}
				projectToEdit={projectToEdit}
				setProjectToEdit={setProjectToEdit}
				setUserSelected={setUserSelected}
				setNewRole={setNewRole}
				projectsList={projectsList}
				setProjectsList={setProjectsList}
			/>
			<RoleActionsModal
				showModal={modals.roleActions}
				roleIdOfChip={roleIdOfChip}
				userIdOfChip={userIdOfChip}
			/>

			<ConfirmationComponent
				open={confirmation?.deleteUsers}
				handleClose={handleCloseDeleteUsersConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={deleteUsersButtonList}
			/>
			<ConfirmationComponent
				open={confirmation?.archiveUsers}
				handleClose={handleCloseArchiveUsersConfirmation}
				title={confirmation['confirmationDetails']['title']}
				dialogContent={confirmation['confirmationDetails']['message']}
				buttonList={archiveUsersButtonList}
			/>
		</div>
	);
};

const mapStateToProps = (state) => ({
	modals: state.modals,
	usersList: state.userManagement.users,
	userClicked: state.userManagement.userClicked,
	confirmation: state.confirmation,
});
export default connect(mapStateToProps, {
	openModal,
	getUsers,
	getCompanies,
	getRoles,
	setProjectSelectedCode,
	getClickedUser,
	setConfirmation,
	closeConfirmation,
})(UserListSection);
